
import axios from "axios";

export default {
  async getMandosAut() {
    const response = await axios.get("/autjustificante");
    return response.data;
  },

  async saveMandoAut(numEmpTitular) {
    await axios({
      url: '/autjustificante',
      method: 'POST',
      data: numEmpTitular,
      headers: {
        'content-Type': 'text/plain' 
      }
    });
  },

  async quitarMandoAut(numEmpTitular) {
    await axios.delete(`/autjustificante/${numEmpTitular}`);
  }
}